import React, { useEffect } from 'react';   
import { Link } from 'react-router-dom'; 
import './about.css';


export default function About() {  
    useEffect(() => {
        document.title = "MOHAMED BAKOUSH | ABOUT";
    }); 

    return (
        <article className="about-article">
            <section className="about-wrapper"> 
                <section>

                    <section className="about-wrapper-content"> 
                        <p className="contact-title">  
                            MY NAME IS
                        </p>
                        <p className="about-description">   
                            MOHAMED BAKOUSH
                        </p>  
                    </section> 
                         
                </section>  
            </section>
        </article>
    )
}